import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { map, Observable, startWith } from "rxjs";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { FormCocinaService } from "../../../../../services/forms/cocina/formCocina.service";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { AventuraService } from "../../../../../services/api/aventura.service";
import Swal from "sweetalert2";
import { FileService } from "../../../../../services/api/file.service";
import { animate, state, style, transition, trigger } from "@angular/animations";
import { IUser, CognitoService } from '../../../../../services/cognito.service'

@Component({
  selector: 'app-dialog-trekking',
  templateUrl: './dialog-trekking.component.html',
  styleUrls: ['./dialog-trekking.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class DialogTrekkingComponent implements OnInit {

  file: any;
  modelExpand: any;
  displayedColumns = ['nombreServicio', 'categoriaServicio', 'nombreProveedor'];
  columnsToDisplayWithExpand = [...this.displayedColumns,];
  options: any = [];
  filteredOptions!: Observable<any[]>;
  myControl = new FormControl<string | any>('');
  proveedorForm = new FormControl<string | any>('');
  services: any = [];
  servicesSourcing: any = [];
  filteredProveedores!: Observable<any[]>;
  tarifaForm = new FormControl<string | any>('');
  tarifas: any = [];
  filteredTarifas!: Observable<any[]>;
  aventuraForm!: FormGroup;
  dataSourceDialog: any;
  dataResult: any = []
  newArray: any = [];
  resultPrueba: any
  arrayServices: any = []
  serviceIDSelected: string | null = null
  user:  string | null = null


  constructor(private router: Router, private fb: FormBuilder, private formService: FormCocinaService,
    public dialogRef: MatDialogRef<DialogTrekkingComponent>, @Inject(MAT_DIALOG_DATA) public dataDialog: any,
    private aventuraService: AventuraService, private fileService: FileService, public Cognito: CognitoService) {

  }

  ngOnInit(): void {

    
/*     this.Cognito.getUser().then(value => {
      this.user = value.attributes.email;
    }) */

    this.user=localStorage.getItem('email')

    this.getAllServices()
    this.dataSourceDialog = new MatTableDataSource();
    this.dataDialog.file.services.map((el: any) => {

      console.log('SERVICIOS  ¿?')
      console.log(el)
      const service = {
        cantPersonal: el.cantPersonal,
        costo: el.costo,
        day: el.day,
        lstPaX: el.lstPaX,
        id: el.id,

        margen: el.margen,
        price: el.price,
        tipoMoneda: el.tipoMoneda,
        totalPriceDolares: el.totalPriceDolares,
        totalPriceSoles: el.totalPriceSoles,
        utilidad: el.utilidad,

        idProducto: el.idProducto,
        idProveedor: el.idProveedor,
        idServicio: el.idServicio,
        idTarifa: el.idTarifa,
        isDeleted: el.isDeleted,
        nombreServicio: el.nombreServicio,
        tipoServicio: el.tipoServicio,
        categoriaServicio: el.categoriaServicio,
        nombreProveedor: el.nombre,
        itineraryIndex: el.itineraryIndex
      }
      this.newArray.push(service);


    })


    console.log('ARRAY INICIAL')
    console.log(this.newArray)

    // const groupByServiceName = this.newArray.reduce((group: { [x: string]: any[]; }, service: { nombreServicio: any; }) => {
    //   const { nombreServicio } = service;
    //   group[nombreServicio] = group[nombreServicio] ?? [];
    //   group[nombreServicio] = [service]
    //   return group;
    // }, {});



    const groupByServiceName2 = this.newArray.map((service: any) => {
      return [service];
    });

    console.log('ARRAY DESPUES')
    // console.log(groupByServiceName)


    // const arrayy = Object.values(groupByServiceName).reverse();
    // console.log(arrayy)

    this.dataSourceDialog.data = groupByServiceName2
    // this.dataSourceDialog.data = arrayy

    // console.log(arrayy)
    // arrayy.map((el: any) => {
    //   this.arrayServices.push(el[0]);
    // })

    this.arrayServices = this.newArray
    console.log(this.arrayServices);

    this.options = this.arrayServices;

    this.getFileById(this.dataDialog.file.fileId);


    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        console.log('VALUE')
        this.serviceIDSelected = value.id
        console.log(value)
        const nombreServicio = typeof value === 'string' ? value : value?.nombreServicio;
        console.log(nombreServicio)
        return nombreServicio ? this._filter1(nombreServicio as string, value.id) : this.options.slice();
      }),
    );

    this.filteredProveedores = this.proveedorForm.valueChanges.pipe(
      startWith(''),
      map(value => {
        const nombre = typeof value === 'string' ? value : value?.nombre;
        return nombre ? this._filter2(nombre as string) : this.services.slice();
      }),
    );

  }


  private _filter2(nombre: string): any[] {

    console.log(this.services)
    const filterValue = nombre.toLowerCase()
    return this.services.filter((option: { nombre: string; }) => option.nombre.toLowerCase().includes(filterValue));
  }

  private _filter1(nombreServicio: string, id: string): any[] {
    console.log(nombreServicio, id)
    console.log(this.options)
    const filterValue = nombreServicio.toLowerCase();
    return this.options.filter((option: { nombreServicio: string; }) => option.nombreServicio.toLowerCase().includes(filterValue));
  }

  getFileById(id: String): void {
    console.log(id)
    this.fileService.getServicesByFile(id).subscribe((response: any) => {

      this.file = response.getServicesByFile
      console.log(response)
      console.log(this.file)
    })


  }

  getAllServices() {

    this.aventuraService.getAllServicesSourcing().subscribe(response => {
      let res = response.getAllServices
      this.servicesSourcing = res;
      // console.log(this.servicesSourcing)

    });

  }


  modifyElement2() {
    console.log(this.dataSourceDialog.data)
    console.log(this.myControl)
    console.log(this.serviceIDSelected)

    this.dataSourceDialog.data.map((ele: { nombreServicio: any; id: any }[]) => {
      if (ele[0].nombreServicio == this.myControl.value.nombreServicio && this.serviceIDSelected === ele[0].id) {


        this.servicesSourcing.map((el: { id: any, itineraryIndex: any; tipoServicio: any, searchTipoProveedor: any, categoriaServicio: any, proveedorNombre: any, nombreServicio: any; servicioProveedorId: any; }) => {


          if (this.serviceIDSelected === ele[0].id && el.nombreServicio == this.myControl.value.nombreServicio && el.servicioProveedorId == this.proveedorForm.value.id) {
            this.dataSourceDialog.data.map((elem: any) => {

              if (elem[0].nombreServicio == el.nombreServicio && elem[0].id===this.serviceIDSelected ) {
                console.log(elem)
                elem[0] = {
                  cantPersonal: elem[0].cantPersonal,
                  costo: elem[0].costo,
                  day: elem[0].day,
                  lstPaX: elem[0].lstPaX,
                  id: elem[0].id,
                  margen: elem[0].margen,
                  price: elem[0].price,
                  tipoMoneda: elem[0].tipoMoneda,
                  totalPriceDolares: elem[0].totalPriceDolares,
                  totalPriceSoles: elem[0].totalPriceSoles,
                  utilidad: elem[0].utilidad,

                  idProducto: elem[0].idProducto,
                  idProveedor: el.servicioProveedorId,
                  idServicio: el.id,
                  idTarifa: elem[0].idTarifa,
                  isDeleted: false,
                  nombreServicio: el.nombreServicio,
                  tipoServicio: el.tipoServicio,
                  categoriaServicio: el.categoriaServicio,
                  nombreProveedor: el.proveedorNombre,
                  itineraryIndex: elem[0].itineraryIndex,
                  changeProvider: true
                }
                // console.log(service)
                // elem = service
                console.log(elem)

              }

              // return elem
            })
          }
        })

      }
    })

    this.dataSourceDialog.data


    this.myControl.setValue('');
    this.proveedorForm.setValue('');

  }


  deleteRow(val: any, i: number): void {

    console.log(val, i);
    console.log(this.dataSourceDialog.data)

    this.dataSourceDialog.data.map((el: any) => {
      if (el[0].nombreServicio == val[0].nombreServicio) {
        //el[i].isArchived=true;
        el[i].isDeleted = true;

      }
    })



  }

  async updatePersonalCampo() {
    console.log(this.dataSourceDialog.data);

    console.log(this.dataSourceDialog.data.map((item: any) => item[0]).filter((srv: any) => srv.changeProvider === true));

    let resultProviderChange = this.dataSourceDialog.data.map((item: any) => item[0]).filter((srv: any) => srv.changeProvider === true)

    // let dataServices: any = [];
    // let otherServices: any = [];
    // let pcServices: any = [];

    // let itinerarios: any = [];

    // this.file.itinerarios.map((itinerary: { services: { productId: any; tipoServicio: any; }[]; }) => {
    //   otherServices = []
    //   console.log(itinerary)
    //   itinerary.services.map((el: { productId: any; tipoServicio: any; }) => {
    //     //if(el.productId==this.dataDialog.file.fileProductId){
    //     if (el.tipoServicio != "GUIA" && el.tipoServicio != "PERSONALDECAMPO") {
    //       otherServices.push(el)
    //       //  }
    //     }
    //   })
    //   console.log(otherServices)

    //   itinerarios.push(otherServices)

    //   console.log(itinerarios)
    // })


    // this.dataSourceDialog.data.map((el: any) => {
    //   el.map((elem: any) => {
    //     dataServices.push(elem);
    //   })
    // })
    // console.log(dataServices);

    // console.log(this.file.itinerarios)

    // dataServices.map((el: {
    //   id: any;
    //   itineraryIndex: any;
    //   cantPersonal: any;
    //   costo: any;
    //   day: any;
    //   lstPaX: any;
    //   margen: any;
    //   price: any;
    //   tipoMoneda: any;
    //   totalPriceDolares: any;
    //   totalPriceSoles: any;
    //   utilidad: any;
    //   idProducto: any;
    //   idProveedor: any;
    //   idServicio: any;
    //   idTarifa: any;
    //   isArchived: any;
    //   isDeleted: any;
    //   itineraryID: any;
    //   nombreServicio: any;
    //   tipoProveedor: any;
    //   tipoServicio: any;
    // }) => {
    //   let serviceUpdate = {
    //     cantPersonal: el.cantPersonal,
    //     costo: el.costo,
    //     day: el.day,
    //     lstPaX: el.lstPaX,
    //     margen: el.margen,
    //     price: el.price,
    //     tipoMoneda: el.tipoMoneda,
    //     totalPriceDolares: el.totalPriceDolares,
    //     totalPriceSoles: el.totalPriceSoles,
    //     utilidad: el.utilidad,

    //     productId: el.idProducto,
    //     providerId: el.idProveedor,
    //     serviceId: el.idServicio,
    //     tarifafId: el.idTarifa,
    //     isDeleted: el.isDeleted,
    //     nombreServicio: el.nombreServicio,
    //     tipoServicio: el.tipoServicio
    //   }
    //   itinerarios[el.itineraryIndex].push(serviceUpdate)
    // })

    // console.log(itinerarios)

    // this.file.itinerarios.map((itinerary: { services: any; }, index: string | number) => {
    //   //console.log(itinerary)
    //   itinerary.services = itinerarios[index]
    //   console.log(itinerary)
    // })

    // console.log(this.file.itinerarios)

    // let itineraries = {
    //   itinerarios: []
    // }
    // itineraries.itinerarios = this.file.itinerarios

    // console.log(this.file)
    // this.fileService.updateItinerary(this.file.id, itineraries).subscribe(response => {
    //   console.log(response);
    //   this.dialogRef.close(1);
    // });


    // const dataResult: any = []




    this.resultPrueba = true

    return await Promise.all(
      resultProviderChange = resultProviderChange.map(async (item: any, index: any) => {

        this.fileService.changeProvider( item.id, item.idProveedor, this.user? this.user.toString() : '').subscribe(

          async (result,) => {
          console.log(result)
          if (result?.changeProvider === true) {
            item.result = true
          } else {
            item.result = false
          }

        }, (err) => {
          console.log(err)
          item.result = false
        }

        )
        return item

      })


      )
      .then((data) => {
        console.log(data)

        // console.log(data.map((el) => el.result))
        // console.log(data.map((el) => el.costo))
        console.log('FINIH')

        return data
      }).then((result) => {
        console.log(result)
        setTimeout(() => {
          this.dataDialog.result = true
          this.dialogRef.close(this.dataDialog);
        }, 2000);
      })

    // console.log(resultProviderChange)




  }

  getOptionText(option: any) {
    return option.nombre;
  }

  getOptionTextService(option: any) {
    return option.nombreServicio;
  }

  getProvidersByService(value: any) {
    this.fileService
      .getProvidersByService(
        value?.nombreServicio || '',
        value?.categoriaServicio || '',
        value?.locacion || ''
      )
      .subscribe({
        next: (envelope) => {
          this.services = envelope?.data ?? [];
        },
        error: (err) => {
          console.error('Error getProvidersByService', err);
          this.services = [];
        }
      });
  }

  servicesByCantPersonalFx() {
    console.log(this.dataDialog.idItinerary)
    this.aventuraService.servicesByCantPersonal(this.dataDialog.idItinerary).subscribe((result) => {
      console.log(result)
      if (result?.servicesByCantPersonal) {


        setTimeout(() => {
          this.dataDialog.result = true
          this.dialogRef.close(this.dataDialog);
        }, 2000);
      }

    }, (err) => {
      console.log(err)
    })

  }
}


// return new Observable<Customer>(suscriptor => {
//   this.http.post(zip)
//       .subscribe (res => {}
//           this.http.post(res)
//               .subscribe (r => {}
//                   Subscriber.Next(r);
//               },
//                 e => subscriber.error(e),
//                 () => subscriber.complete());
//       });
